import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import Box from 'components/Box';
import SelectInput from 'components/forms/SelectInput';
import Text from 'components/Text';

import { cxHelpers } from 'util/className';
const { cxEl } = cxHelpers('OnboardingPacketRow');
import { toI18n } from 'util/i18n';

import { CONTRACTOR_TYPE_OPTIONS } from '../../../constants';

const ContractorTypeSelectInput = ({
  handleContractorTypeChange,
  contractorType,
  errorBorder,
  hasNoActivePayments,
}) => (
  <Box pb24>
    <Box pb8>
      <Text fs14 fw600 i18n="add_team.individual_drawer.contractor_type" />
    </Box>
    <Box>
      <SelectInput
        errorBorder={
          hasNoActivePayments && errorBorder && isEmpty(contractorType)
        }
        placeholder={toI18n(
          'add_team.individual_drawer.contractor_type_placeholder'
        )}
        options={CONTRACTOR_TYPE_OPTIONS}
        searchable={false}
        onChange={handleContractorTypeChange}
        value={contractorType}
        className={cxEl('contractorType')}
      />
    </Box>
  </Box>
);

ContractorTypeSelectInput.propTypes = {
  handleContractorTypeChange: PropTypes.func.isRequired,
  contractorType: PropTypes.string,
  errorBorder: PropTypes.bool,
  hasNoActivePayments: PropTypes.bool,
};

export default ContractorTypeSelectInput;
